import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const AttendanceSuccess = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { attendance, project } = location.state || {};

    if (!attendance) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
                <div className="bg-white w-full max-w-md rounded-2xl shadow-xl p-8 text-center rounded-xl md:p-12">
                    <p className="text-gray-600 mb-6">No attendance data found</p>
                    <button
                        className="bg-black text-white font-bold py-3 px-6 rounded-lg hover:bg-gray-800 transition-colors shadow-lg"
                        onClick={() => navigate('/')}
                    >
                        Go Home
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 font-sans">
            <div className="bg-white w-full max-w-md rounded-2xl shadow-xl overflow-hidden rounded-xl md:max-w-lg">
                <div className="bg-green-500 p-8 text-center">
                    <div className="text-6xl mb-4 bg-white/20 w-20 h-20 rounded-full flex items-center justify-center mx-auto backdrop-blur-sm">
                        ✅
                    </div>
                </div>

                <div className="p-8">
                    <div className="text-center mb-8">
                        <h1 className="text-3xl font-bold text-gray-900 mb-2">Attendance Marked!</h1>
                        <p className="text-gray-600">Your attendance has been successfully recorded.</p>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6 mb-8 border border-gray-100">
                        <h3 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4 border-b border-gray-200 pb-2">
                            Attendance Details
                        </h3>

                        <div className="space-y-3">
                            <div className="flex justify-between items-start">
                                <span className="text-gray-500 text-sm">Name</span>
                                <span className="font-semibold text-gray-900 text-right">{attendance.member_name}</span>
                            </div>

                            {attendance.admission_number && (
                                <div className="flex justify-between items-start">
                                    <span className="text-gray-500 text-sm">Admission No</span>
                                    <span className="font-semibold text-gray-900 text-right">{attendance.admission_number}</span>
                                </div>
                            )}

                            {attendance.nic_number && (
                                <div className="flex justify-between items-start">
                                    <span className="text-gray-500 text-sm">NIC No</span>
                                    <span className="font-semibold text-gray-900 text-right">{attendance.nic_number}</span>
                                </div>
                            )}

                            <div className="flex justify-between items-start">
                                <span className="text-gray-500 text-sm">Project</span>
                                <span className="font-semibold text-gray-900 text-right">{project?.name}</span>
                            </div>

                            <div className="flex justify-between items-start">
                                <span className="text-gray-500 text-sm">Status</span>
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                    {attendance.status}
                                </span>
                            </div>

                            <div className="flex justify-between items-start">
                                <span className="text-gray-500 text-sm">Time</span>
                                <span className="font-semibold text-gray-900 text-right">
                                    {new Date(attendance.created_at).toLocaleString()}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="text-center">
                        <p className="text-gray-400 text-sm font-medium">
                            Thank you for your participation!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AttendanceSuccess;
